import { render, staticRenderFns } from "./PDFTable.vue?vue&type=template&id=357ec7ea&"
import script from "./PDFTable.vue?vue&type=script&lang=ts&"
export * from "./PDFTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports